<template>
  <div class="container-fluid">
    <b-overlay :show="showOverlay" rounded="sm">
      <b-col class="container text-right"> </b-col>

      <b-card class="mt-2 col-12">
        <b-tabs>
          <b-tab
            v-for="tab in tabs"
            :key="tab.title"
            :title="tab.title"
            lazy
            @click.prevent="setActiveTabName(tab.mode)"
          >
            <b-col cols="12">
              <SearchFilter
                :mode="tab.mode"
                @handleSubmit="searchFilterSubmit"
              />
            </b-col>
          </b-tab>
        </b-tabs>
      </b-card>

      <b-card v-for="tab in activeTab" :id="tab" :key="tab" cols="12">
        <commonTable
          ref="tableCommon"
          :mode="tab"
          @handleSend="getManageDetail"
          @handleGroup="getManageGroup"
          @handleOverlay="setOverlay"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
  BOverlay,
} from "bootstrap-vue";
import commonTable from "./components/commonTable.vue";
import SearchFilter from "./components/SearchFilter.vue";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    BOverlay,
    commonTable,
    SearchFilter,
  },
  data() {
    return {
      tabs: [{ title: "จัดการสิทธิ์ผู้ใช้งาน", mode: "List" }],
      activeTab: ["List"],
      showOverlay: false,
    };
  },
  methods: {
    setOverlay(isShow) {
      this.showOverlay = isShow;
    },
    setActiveTabName(name) {
      this.activeTab = [];
      this.activeTab.push(name);
    },
    getManageDetail(id) {
      // let routeData = this.$router.resolve({name: 'LawScreeningManage', query: { id:id } });
      // window.open(routeData.href, '_blank');
    },
    getManageGroup(id) {
      // let routeData = this.$router.resolve({name: 'LawGroupdManage' });
      // window.open(routeData.href, '_blank');
      if (this.activeTab[0] == "GroupProcess") {
        const routeData = this.$router.resolve({
          name: "ScreeningGroupManage",
          query: { id },
        });
        window.open(routeData.href, "_blank");
      } else {
        //(this.activeTab[0]=='List' || this.activeTab[0]=='Group')
        const routeData = this.$router.resolve({
          name: "ScreeningManage",
          query: { id },
        });
        window.open(routeData.href, "_blank");
      }
    },
    searchFilterSubmit(params) {
      this.$refs.tableCommon[0].onSearchSubmit(params);
    },
    onBtnAddClicked() {
      window.open(this.$router.resolve({ name: "RoleManage" }).href, "_blank");
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
